module.exports = __webpack_public_path__ + "assets/img/Henry Park Primary School.0f1f50ca.jpg";